export const dayKey = (d) => {
  const _ = new Date(d);
  return `${_.getFullYear()}-${String(_.getMonth() + 1).padStart(2, '0')}-${String(_.getDate()).padStart(2, '0')}`;
};

export const entryMatchesDate = (entry, dateObj) => {
  if (!dateObj || !entry) return !dateObj;
  const day = dayKey(dateObj);
  if (entry.entry_type === 'appuntamento') {
    try { return !!(entry.start_time && dayKey(entry.start_time) === day); } catch { return false; }
  }
  try { return dayKey(entry.timestamp || entry.date || entry.start_time) === day; } catch { return false; }
};

export const calcClickTime = (offsetY, selectedDate, dayHeight) => {
  const minutes = Math.round((offsetY / dayHeight) * 24 * 60);
  const sel = selectedDate ? new Date(selectedDate) : new Date();
  return new Date(sel.getFullYear(), sel.getMonth(), sel.getDate(), Math.floor(minutes / 60), minutes % 60, 0, 0);
};
